<ng-container *ngIf="totalResults > 0">
  <div>{{ totalResults }} {{ 'common.results' | cxTranslate }}</div>
  <div class="cx-vertical-line-separator"></div>
  <div>
    {{ fromItem }}-{{ toItem }} {{ 'common.of' | cxTranslate }}
    {{ totalResults }}
  </div>
</ng-container>
